<div class="split-auth-container">
  <!-- Left Panel -->
  <div class="split-left-panel">
    <div class="split-left-bg">
      <img src="assets/images/wedding.jpg" alt="Wedding Couple" class="split-left-img">
      <div class="split-left-overlay"></div>
    </div>
    <div class="split-left-content">
      <span class="left-tagline">A Heritage of Love</span>
      <h1 class="left-title">Find Your Perfect Life Partner</h1>
      <p class="left-desc">
        Experience a matrimonial journey built on tradition, family values, and curated connections. Where heritage
        meets modern search capabilities.
      </p>

      <div class="trust-badge-list">
        <div class="trust-badge-item">
          <span class="material-symbols-outlined icon">verified_user</span>
          <div class="badge-text">
            <h4>Verified Profiles</h4>
            <p>Every account goes through a thorough check for secure matchmaking</p>
          </div>
        </div>
        <div class="trust-badge-item">
          <span class="material-symbols-outlined icon">chat</span>
          <div class="badge-text">
            <h4>Secure Messaging</h4>
            <p>Your privacy and safety are always our top concern</p>
          </div>
        </div>
        <div class="trust-badge-item">
          <span class="material-symbols-outlined icon">shield</span>
          <div class="badge-text">
            <h4>Privacy Protected</h4>
            <p>Full control over your photos and profile visibility</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Panel -->
  <div class="split-right-panel">
    <!-- Mobile-only Banner -->
    <div class="mobile-onboarding-banner">
      <img src="assets/images/wedding.jpg" alt="Wedding Couple" class="mobile-banner-img">
      <div class="mobile-banner-overlay"></div>
      <div class="mobile-banner-text">
        <span class="left-tagline">A Heritage of Love</span>
        <h3>Find Your Perfect Partner</h3>
      </div>
    </div>

    <div class="onboarding-card">
      <div class="auth-header">
        <a routerLink="/" class="logo">Weddingly Matrimony</a>

        <!-- Progress Stepper -->
        <div class="step-progress-wrapper">
          <span class="progress-step-text">Step 4 of 4: Professional Details</span>
          <div class="stepper-bar">
            <div class="stepper-progress" style="width: 100%;"></div>
          </div>
        </div>

        <h2>Professional & Location</h2>
        <p>Complete the final step by adding your education, work, and location details</p>
      </div>

      <form [formGroup]="signupprofessional" (ngSubmit)="onSubmit()" class="auth-form">
        <div class="row">
          <div class="col-md-6 form-group">
            <label for="education">Education</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">school</span>
              <div class="custom-dropdown">

                <div class="warm-input dropdown-box" (click)="openDropdown('education')">

                  <span class="material-symbols-outlined input-icon">
                    school
                  </span>

                  {{selectedEducation || 'Select Education'}}

                </div>


                <div class="search-dropdown" *ngIf="showDropdown === 'education'">

                  <input type="text" placeholder="Search Education" class="search-input"
                    (input)="filterDropdown($event,'education')">


                  <div class="dropdown-item" *ngFor="let edu of filteredEducations"
                    (click)="selectItem(edu,'education')">

                    {{edu.education_nme}}

                  </div>

                </div>

              </div>
            </div>
            <span class="error-msg"
              *ngIf="signupprofessional.get('education')?.touched && signupprofessional.get('education')?.invalid">
              Education is required
            </span>
          </div>

          <div class="col-md-6 form-group">
            <label for="highest">Higher Education</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">school</span>
              <div class="custom-dropdown">

                <div class="warm-input dropdown-box" (click)="openDropdown('highest'); $event.stopPropagation()">

                  {{selectedHighest || 'Select Higher Education'}}

                </div>


                <div class="search-dropdown" *ngIf="showDropdown === 'highest'">

                  <input type="text" placeholder="Search Higher Education" class="search-input"
                    (input)="filterDropdown($event,'highest')">


                  <div class="dropdown-item" *ngFor="let high of filteredHighests" (click)="selectItem(high,'highest')">

                    {{high.highereducation_nme}}

                  </div>

                </div>

              </div>
            </div>
            <span class="error-msg"
              *ngIf="signupprofessional.get('highest')?.touched && signupprofessional.get('highest')?.invalid">
              Higher education is required
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 form-group">
            <label for="education_detail">College / Institution <span style="font-weight: 400; color: #777;">(Optional)</span></label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">account_balance</span>
              <input type="text" id="education_detail" formControlName="education_detail" class="warm-input" placeholder="e.g., BCA at SRM Institute of Science and Technology">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 form-group">
            <label for="employment">Employment Type</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">work</span>
              <div class="custom-dropdown">

                <div class="warm-input dropdown-box" (click)="openDropdown('employment')">

                  {{selectedEmployment || 'Select Employment'}}

                </div>


                <div class="search-dropdown" *ngIf="showDropdown === 'employment'">

                  <input class="search-input" placeholder="Search Employment"
                    (input)="filterDropdown($event,'employment')">


                  <div class="dropdown-item" *ngFor="let emp of filteredEmployments"
                    (click)="selectItem(emp,'employment')">

                    {{emp.employment_type_nme}}

                  </div>

                </div>

              </div>
            </div>
            <span class="error-msg"
              *ngIf="signupprofessional.get('employment')?.touched && signupprofessional.get('employment')?.invalid">
              Employment type is required
            </span>
          </div>

          <div class="col-md-6 form-group">
            <label for="occupation">Occupation Category</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">work</span>
              <div class="custom-dropdown">

                <div class="warm-input dropdown-box" (click)="openDropdown('occupation')">

                  {{selectedOccupation || 'Select Occupation Category'}}

                </div>


                <div class="search-dropdown" *ngIf="showDropdown === 'occupation'">

                  <input class="search-input" placeholder="Search Occupation Category"
                    (input)="filterDropdown($event,'occupation')">


                  <div class="dropdown-item" *ngFor="let occ of filteredOccupations"
                    (click)="selectItem(occ,'occupation')">

                    {{occ.occupation_nme}}

                  </div>

                </div>

              </div>
            </div>
            <span class="error-msg"
              *ngIf="signupprofessional.get('occupation')?.touched && signupprofessional.get('occupation')?.invalid">
              Occupation Category is required
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 form-group">
            <label for="occupation_detail">Designation / Job Title <span style="font-weight: 400; color: #777;">(Optional)</span></label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">badge</span>
              <input type="text" id="occupation_detail" formControlName="occupation_detail" class="warm-input" placeholder="e.g., Senior Java Developer at TCS">
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="income">Annual Income</label>
          <div class="input-with-icon">
            <span class="material-symbols-outlined input-icon">payments</span>
            <div class="custom-dropdown">

              <div class="warm-input dropdown-box" (click)="openDropdown('income'); $event.stopPropagation()">

                {{selectedIncome || 'Select Income Range'}}

              </div>


              <div class="search-dropdown" *ngIf="showDropdown === 'income'">

                <input class="search-input" placeholder="Search Income" (input)="filterDropdown($event,'income')">


                <div class="dropdown-item" *ngFor="let inc of filteredIncomes" (click)="selectItem(inc,'income')">

                  {{inc.income_nme}}

                </div>
              </div>
            </div>
          </div>
          <span class="error-msg"
            *ngIf="signupprofessional.get('income')?.touched && signupprofessional.get('income')?.invalid">
            Income details is required
          </span>
        </div>

        <div class="form-group">
          <label for="additional_income_source">Additional Income Source <span style="font-weight: 400; color: #777;">(Optional)</span></label>
          <div class="input-with-icon">
            <span class="material-symbols-outlined input-icon">add_card</span>
            <div class="custom-dropdown">
              <div class="warm-input dropdown-box" (click)="openDropdown('addIncome'); $event.stopPropagation()">
                {{ signupprofessional.get('additional_income_source')?.value || 'Select Additional Income Source' }}
              </div>
              <div class="search-dropdown" *ngIf="showDropdown === 'addIncome'">
                <div class="dropdown-item" *ngFor="let src of additionalIncomeSources" (click)="selectAddIncomeSource(src)">
                  {{ src }}
                </div>
                <div class="dropdown-item" style="color: #B01E3E; font-weight: 600;" *ngIf="signupprofessional.get('additional_income_source')?.value" (click)="selectAddIncomeSource('')">
                  Clear Selection
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group" *ngIf="isCustomAddIncome(signupprofessional.get('additional_income_source')?.value)">
          <label for="custom_add_income_src">Specify Additional Income Source <span style="color: #B01E3E;">*</span></label>
          <div class="input-with-icon">
            <span class="material-symbols-outlined input-icon">edit</span>
            <input type="text" id="custom_add_income_src" [value]="(signupprofessional.get('additional_income_source')?.value === 'Other (Specify / Type Custom)' || signupprofessional.get('additional_income_source')?.value === 'Other') ? '' : signupprofessional.get('additional_income_source')?.value" (input)="onCustomAddIncomeInput($event)" class="warm-input" placeholder="Type custom source (e.g. Stock Dividends, Royalty, Pension)...">
          </div>
        </div>

        <div class="form-group" *ngIf="signupprofessional.get('additional_income_source')?.value">
          <label for="additional_annual_income">Additional Annual Income (₹) <span style="color: #B01E3E;">*</span></label>
          <div class="input-with-icon">
            <span class="material-symbols-outlined input-icon">currency_rupee</span>
            <input type="number" id="additional_annual_income" formControlName="additional_annual_income"
              class="warm-input" placeholder="e.g. 250000" min="1">
          </div>
          <span class="error-msg" *ngIf="signupprofessional.get('additional_annual_income')?.touched && signupprofessional.get('additional_annual_income')?.invalid">
            <span *ngIf="signupprofessional.get('additional_annual_income')?.errors?.['required']">Additional annual income is required when source is selected</span>
            <span *ngIf="signupprofessional.get('additional_annual_income')?.errors?.['pattern'] || signupprofessional.get('additional_annual_income')?.value <= 0">Please enter a valid positive numeric amount</span>
          </span>
        </div>

        <div class="row">
          <div class="col-md-6 form-group">
            <label for="country">Country</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">public</span>
              <div class="custom-dropdown">

                <div class="warm-input dropdown-box" (click)="openDropdown('country'); $event.stopPropagation()">

                  {{selectedCountry || 'Select Country'}}

                </div>


                <div class="search-dropdown" *ngIf="showDropdown === 'country'">

                  <input class="search-input" placeholder="Search Country" (input)="filterDropdown($event,'country')">


                  <div class="dropdown-item" *ngFor="let cntry of filteredCountrys"
                    (click)="selectItem(cntry,'country')">

                    {{cntry.name_0}}

                  </div>

                </div>

              </div>
            </div>
            <span class="error-msg"
              *ngIf="signupprofessional.get('country')?.touched && signupprofessional.get('country')?.invalid">
              Country is required
            </span>
          </div>

          <div class="col-md-6 form-group">
            <label for="state">State</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">map</span>
              <div class="custom-dropdown">

                <div class="warm-input dropdown-box" (click)="openDropdown('state'); $event.stopPropagation()">

                  {{selectedState || 'Select State'}}

                </div>


                <div class="search-dropdown" *ngIf="showDropdown === 'state'">

                  <input class="search-input" placeholder="Search State" (input)="filterDropdown($event,'state')">


                  <div class="dropdown-item" *ngFor="let st of filteredStates" (click)="selectItem(st,'state')">

                    {{st.name_1}}

                  </div>

                </div>

              </div>
            </div>
            <span class="error-msg"
              *ngIf="signupprofessional.get('state')?.touched && signupprofessional.get('state')?.invalid">
              State is required
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 form-group">
            <label for="district">District</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">map</span>
              <div class="custom-dropdown">

                <div class="warm-input dropdown-box" (click)="openDropdown('district'); $event.stopPropagation()">

                  {{selectedDistrict || 'Select District'}}

                </div>


                <div class="search-dropdown" *ngIf="showDropdown === 'district'">

                  <input class="search-input" placeholder="Search District" (input)="filterDropdown($event,'district')">


                  <div class="dropdown-item" *ngFor="let dist of filteredDistricts"
                    (click)="selectItem(dist,'district')">

                    {{dist.name_2}}

                  </div>

                </div>

              </div>
            </div>
            <span class="error-msg"
              *ngIf="signupprofessional.get('district')?.touched && signupprofessional.get('district')?.invalid">
              District is required
            </span>
          </div>

          <div class="col-md-4 form-group">
            <label for="city">City</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">location_city</span>
              <div class="custom-dropdown">

                <div class="warm-input dropdown-box" (click)="openDropdown('city'); $event.stopPropagation()">

                  {{selectedCity || 'Select City'}}

                </div>


                <div class="search-dropdown" *ngIf="showDropdown === 'city'">

                  <input class="search-input" placeholder="Search City" (input)="filterDropdown($event,'city')">


                  <div class="dropdown-item" *ngFor="let ct of filteredCitys" (click)="selectItem(ct,'city')">

                    {{ct.city_nme}}

                  </div>

                </div>

              </div>
            </div>
            <span class="error-msg"
              *ngIf="signupprofessional.get('city')?.touched && signupprofessional.get('city')?.invalid">
              City is required
            </span>
          </div>

          <div class="col-md-4 form-group">
            <label for="pincode">Pincode</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">pin_drop</span>
              <input type="text" id="pincode" formControlName="pincode" class="warm-input" placeholder="600045"
                [class.invalid]="signupprofessional.get('pincode')?.touched && signupprofessional.get('pincode')?.invalid">
            </div>
            <span class="error-msg"
              *ngIf="signupprofessional.get('pincode')?.touched && signupprofessional.get('pincode')?.hasError('required')">
              Pincode is required
            </span>
            <span class="error-msg"
              *ngIf="signupprofessional.get('pincode')?.touched && signupprofessional.get('pincode')?.hasError('pattern')">
              Numbers only
            </span>
          </div>
        </div>

        <hr class="section-divider">

        <div class="row">
          <div class="col-md-6 form-group">
            <label for="familyType">Family Type</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">group</span>
              <select 
                id="familyType" 
                formControlName="familyType" 
                class="warm-input"
                [class.invalid]="signupprofessional.get('familyType')?.touched && signupprofessional.get('familyType')?.invalid"
              >
                <option value="" disabled selected>Select Family Type</option>
                <option value="Nuclear">Nuclear</option>
                <option value="Joint">Joint</option>
              </select>
            </div>
            <span class="error-msg" *ngIf="signupprofessional.get('familyType')?.touched && signupprofessional.get('familyType')?.invalid">
              Family type is required
            </span>
          </div>

          <div class="col-md-6 form-group">
            <label for="familyStatus">Family Status</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">home</span>
              <select 
                id="familyStatus" 
                formControlName="familyStatus" 
                class="warm-input"
                [class.invalid]="signupprofessional.get('familyStatus')?.touched && signupprofessional.get('familyStatus')?.invalid"
              >
                <option value="" disabled selected>Select Status</option>
                <option value="Middle Class">Middle Class</option>
                <option value="Upper Middle Class">Upper Middle Class</option>
                <option value="High Class">High Class</option>
                <option value="Rich/Affluent">Rich/Affluent</option>
              </select>
            </div>
            <span class="error-msg" *ngIf="signupprofessional.get('familyStatus')?.touched && signupprofessional.get('familyStatus')?.invalid">
              Family status is required
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 form-group">
            <label for="fatherJob">Father's Occupation</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">work</span>
              <input 
                type="text" 
                id="fatherJob" 
                formControlName="fatherJob" 
                class="warm-input" 
                placeholder="Business, Retired, etc."
              >
            </div>
          </div>

          <div class="col-md-6 form-group">
            <label for="motherJob">Mother's Occupation</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">work</span>
              <input 
                type="text" 
                id="motherJob" 
                formControlName="motherJob" 
                class="warm-input" 
                placeholder="Homemaker, Teacher, etc."
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 form-group">
            <label for="brothers">No. of Brothers</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">escalator_warning</span>
              <input 
                type="number" 
                id="brothers" 
                formControlName="brothers" 
                class="warm-input" 
                min="0"
                placeholder="0"
              >
            </div>
          </div>

          <div class="col-md-6 form-group">
            <label for="sisters">No. of Sisters</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">escalator_warning</span>
              <input 
                type="number" 
                id="sisters" 
                formControlName="sisters" 
                class="warm-input" 
                min="0"
                placeholder="0"
              >
            </div>
          </div>
        </div>

        <!-- Aadhaar Identity Verification Section -->
        <div class="auth-section-title mt-4 mb-3" style="display: flex; align-items: center; gap: 8px;">
          <span class="material-symbols-outlined" style="color: #b01e3e;">badge</span>
          <h3 style="margin: 0; font-size: 14px; font-weight: bold; color: #333;">Identity Verification (Optional)</h3>
        </div>

        <div class="row">
          <div class="col-12 form-group mb-3">
            <label for="aadhaar">Aadhaar Card (Front Side only) – JPG, JPEG, PNG, or PDF</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">upload_file</span>
              <input 
                type="file" 
                id="aadhaar" 
                (change)="onAadhaarSelected($event)"
                accept=".jpg,.jpeg,.png,.pdf"
                class="warm-input py-2"
                style="padding-left: 36px; padding-top: 8px; padding-bottom: 8px;"
              >
            </div>
            <div class="form-text text-muted mt-2" style="font-size: 11px; display: flex; align-items: center; gap: 4px; color: #666;">
              <span class="material-symbols-outlined" style="font-size: 14px; color: #b01e3e;">info</span>
              <span>Your Aadhaar is used only for identity verification and will never be displayed to other users.</span>
            </div>
          </div>
        </div>

        <button type="submit" class="gold-button submit-btn">
          <span>Complete Registration</span>
          <span class="material-symbols-outlined">how_to_reg</span>
        </button>

        <div class="trust-note">
          <span class="material-symbols-outlined trust-lock">lock</span>
          <span>Your information is private and secure</span>
        </div>
      </form>
    </div>
  </div>
</div>